export const pallete = {
	white1: '#fff',
	blue1: '#2185d0', // brand.semantic.simple.blue
	blue2: '#1678c2', // brand.semantic.hover.blue
	blue3: '#378abb12',
	blue4: '#173F5F', // chart color
	blue5: '#173F5F20', // chart bg
	blue6: '#20639B', // chart color
	blue7: '#20639B20', // chart bg
	blue8: '#106ba3', // link color - from Blueprint, btn hover bg
	blue9: '#00aaff', // coin mech tube high level
	blue10: '#137cbd', // blue create buttons
	blue11: '#509acd', // blue icon color
	blue12: '#66aeff', // blue icon color 2
	blue13: '#173F5F80', // DARK - chart bg blue color
	blue14: '#1190f0', // DARK - links
	blue15: '#18202f', // DARK BLUE - dashboard, main bg
	blue16: '#212939', // DARK BLUE - raised pages
	blue17: '#283245', // DARK BLUE - Drop boxes/Pending and Picked boxes
	blue18: '#323e54', // DARK BLUE - button hover, scroll bar thumb bg
	blue19: '#414c63', // DARK BLUE - scroll bar track bg
	blue20: 'rgba(24, 32, 47, 0.3)', // DARK BLUE - spinner bg
	black1: '#272f3b', // !!! brand.black
	black2: '#182026', // blueprint - light theme text color
	black3: 'rgba(40, 40, 40, 0.8)', // low black
	grey1: '#dddddd70', // brand.HCGNA.color
	grey2: '#727272', // !!! brand.grey4
	grey3: '#999999', // !!! brand.grey3, placeholder text
	grey4: '#ddd', // brand.HCGNA.color border
	grey5: '#E8E8E8', // default simple
	grey6: '#dedede', // default hover
	grey7: '#bcbcbc', // brand.semantic.simple.grey
	grey8: '#838383', // brand.semantic.hover.grey
	grey9: '#727fa3',
	grey10: 'rgba(92, 112, 128, 0.6)', // copies blueprint disabled colors
	grey11: 'rgba(206, 217, 224, 0.5)', // copies blueprint disabled colors
	grey13: '#E4E9ED',
	grey14: '#f5f8fa',
	grey16: '#a7b6c2', // blueprint - light theme subtext color
	grey17: '#34373C', // DARK - discord
	grey18: '#36393F', // DARK - discord
	grey19: '#393C43', // DARK - discord
	grey20: '#2F3136', // DARK - discord (main app bg)
	grey21: '#585F67', // DARK - hover bg for Dashboard link
	grey22: 'hsla(0,0%,100%,0.06)', // DARK - discord border
	grey23: '#202225', // DARK - discord
	grey24: '#CCC', // LIGHT - discord
	grey25: '#4f545c', // DARK - discord
	grey26: '#f8f9f9', // LIGHT - discord
	grey27: '#292b2f', // DARK - discord
	grey28: '#d8e1e8', // DARK/LIGHT - blueprint day hover bg
	grey29: '#ebf6ff', // LIGHT - hover bg
	grey30: 'rgba(255, 255, 255, 0.3)', // LIGHT - spinner bg
	grey31: 'rgba(47, 49, 54, 0.3)', // DARK - spinner bg
	grey32: '#fbfbfb66', // LIGHT - original main app bg
	grey33: '#f4f7fb', // LIGHT - original list & table header bg
	grey34: '#EEE', // planogram item footer, coin mech icon
	grey35: '#e0e0e0d1', // header bottom border
	grey36: '#b9bbbe', // DARK - main text color
	grey37: '#bbb', // LIGHT - placeholder, disabled text
	grey38: '#2a2c30', // DARK = planogram item bg
	grey39: '#545f7d', // icon color
	grey40: '#ebf1f5', // bp6- dialogue bg
	grey41: '#c9cdcf', // multi-select list outer border
	grey42: '#eceffa', // selected planogram item bg
	grey43: '#fff1d2', // queued planogram item bg
	grey44: '#8e9297', // DARK - hint text color
	grey45: '#5d616b', // DARK - planogram item selection overlay
	grey46: '#43464a', // DARK - tooltip bg
	grey47: '#5c7080', // non-editable planogram item input
	grey48: '#F9F9F9',
	grey49: '#373738',
	yellow1: '#ffe96080', // brand.HCGamber.color
	yellow2: '#ffdb65', // brand.HCGamber.color border
	yellow3: '#F6D55C20',
	yellow4: '#FED89E', // LIGHT - planogram item footer
	yellow5: '#d9bd93', // DARK - planogram item footer
	green1: '#33e2bc50', // brand.HCGgreen.color
	green2: '#51d6b9', // brand.HCGgreen.color border
	green3: '#21ba45', // brand.semantic.simple.green
	green4: '#16ab39', // brand.semantic.hover.green
	green5: '#b5cc18', // brand.semantic.simple.olive
	green6: '#a7bd0d', // brand.semantic.hover.olive
	green7: '#00b5ad', // brand.semantic.simple.teal
	green8: '#009c95', // brand.semantic.hover.teal
	green9: '#3CAEA3', // chart color
	green10: '#3CAEA320', // chart bg
	green12: '#3dad57', // DARK - green label, icon etc.
	green13: '#2e8542', // DARK - green label hover
	green14: '#B7E4A6', // LIGHT - planogram item footer
	green15: '#9bb88f', // DARK - planogram item footer
	green16: '#b7e4a6', // planogram item salesLast30Days background
	red1: '#ff8c9e7a', // brand.HCGred.color
	red2: '#d2929d', // brand.HCGred.color border
	red3: '#db2828', // brand.semantic.simple.red
	red4: '#d01919', // brand.semantic.hover.red
	red5: '#ED553B',
	red6: '#ED553B20',
	red8: '#de3232', // coin mech tube low level
	red9: '#af5b5e', // X icon color
	red10: '#cf4040', // DARK - red label, icon etc.
	red11: '#a83434', // DARK - red label hover
	red12: '#F5BEBE', // LIGHT - planogram item footer
	red13: '#c9a1a1', // DARK - planogram item footer
	orange1: '#f5b600', // brand.semantic.simple.yellow
	orange2: '#eaae00', // brand.semantic.hover.yellow
	orange3: '#f2711c', // brand.semantic.simple.orange
	orange4: '#f26202', // brand.semantic.hover.orange
	orange5: '#fc8c14', // bottom border of the seleceted tab
	orange6: '#fff8f1', // bg of the selected horizontal tab
	orange7: '#fef8f1', // bg of the hovered horizontal tab
	orange8: '#ff8100', // activeLabel text (vertical tabs)
	orange9: '#ffe9d3', // bg for the current day, selected vertical tab
	orange10: '#e0732b', // DARK - orange label, icon etc.
	orange11: '#bf5c1b', // DARK - orange label hover
	orange12: '#d6a518', // DARK - yellow label, icon etc.
	orange13: '#bd9115', // DARK - yellow label hover
	purple1: '#be37db',
	purple2: '#4B0082', // DARK - purple label, icon etc.
	navy1: '#001f3f', // Navy for Rocket tier
	pink1: '#ff69b4', // Pink for Supernova tier
	banana1: '#ffe135', // Banana yellow
	// Semantic status colors (mobile status icons/accents); mid-luminance so
	// they read on both light and dark backgrounds.
	statusGreen1: '#10b981',
	statusAmber1: '#f59e0b',
	statusRed1: '#ef4444',
	statusBlue1: '#3b82f6',
	boxShadow1:
    '0 0 0 1px #d4d4d5, 0 2px 4px 0 rgba(34,36,38,.12), 0 2px 10px 0 rgba(34,36,38,.15)',
	boxShadow2: '0px 11px 8px -10px #e8e8e8, 0px -11px 8px -10px #e8e8e8',
	boxShadow3: '0px 11px 8px -10px #888, 0px -11px 8px -10px #888',
	// blueprint -- light theme input focus shadow
	boxShadow4:
    '0 0 0 1px #137cbd, 0 0 0 3px rgba(19,124,189,.3), inset 0 1px 1px rgba(16,22,26,.2)',
	// blueprint -- dark theme input focus shadow
	boxShadow5:
    '0 0 0 1px #137cbd, 0 0 0 1px #137cbd, 0 0 0 3px rgba(19,124,189,.3), inset 0 0 0 1px rgba(16,22,26,.3), inset 0 1px 1px rgba(16,22,26,.4)',
	// blueprint -- light theme input shadow
	boxShadow6:
    '0 0 0 0 rgba(19,124,189,0), 0 0 0 0 rgba(19,124,189,0), inset 0 0 0 1px rgba(16,22,26,.15), inset 0 1px 1px rgba(16,22,26,.2)',
	// blueprint -- dark theme input shadow
	boxShadow7:
    '0 0 0 0 rgba(19,124,189,0), 0 0 0 0 rgba(19,124,189,0), 0 0 0 0 rgba(19,124,189,0), inset 0 0 0 1px rgba(16,22,26,.3), inset 0 1px 1px rgba(16,22,26,.4)',
	boxShadow8: '0px 1px 6px 0px #e6e6e6', // header bottom shadow
	boxShadow9: '0 1px 3px #bbb', // panels shadow
	boxShadow10:
    'rgb(212, 212, 213) 0px 0px 0px 1px, rgba(34, 36, 38, 0.12) 0px 2px 4px 0px, rgba(34, 36, 38, 0.15) 0px 2px 10px 0px', // planogram item shadow
	textShadow1: '.05rem .05rem #888',
};

// Shown as "Onyx": a near-black, Discord Onyx-like dark theme, offered in the Sentry web apps and the Sentry Chat phone app.
// The saved mode stays 'obsidian' so people who already chose it keep it.
export const OBSIDIAN_MODE = 'obsidian';
export const OBSIDIAN_COLORS = {
	bg: '#131416',
	bgSecondary: '#0C0C0E',
	bgTertiary: '#070709',
	hover: '#1C1D21',
	active: '#26272C',
	input: '#1D1E22',
	border: '#26272B',
	borderStrong: '#35363C',
	text: '#DBDEE1',
	mutedText: '#949BA4',
	strongText: '#F2F3F5',
	// Filled buttons and badges, with white text.
	accent: '#5865F2',
	accentHover: '#4752C4',
	accentActive: '#3C45A5',
	// Links, mentions and accent text on the dark greys.
	accentOnDark: '#949CF7',
};

// Obsidian starts from the dark theme, so tokens it does not list (success, danger, labels) stay as they are there.
// The Sentry Chat phone app uses exactly these tokens.
export const OBSIDIAN_THEME_COLORS = {
	mainBg1: OBSIDIAN_COLORS.bg,
	mainBg3: OBSIDIAN_COLORS.hover,
	mainBg4: OBSIDIAN_COLORS.bgSecondary,
	mainBg5: OBSIDIAN_COLORS.active,
	mainBg10: OBSIDIAN_COLORS.bgTertiary,
	mainBg12: OBSIDIAN_COLORS.hover,
	mainBg15: OBSIDIAN_COLORS.input,
	mainBg18: OBSIDIAN_COLORS.bgSecondary,
	mainBg28: OBSIDIAN_COLORS.bg,
	inputDisabledBg: OBSIDIAN_COLORS.bgSecondary,
	spinnerBg: 'rgba(19, 20, 22, 0.3)',
	border1: OBSIDIAN_COLORS.border,
	border2: OBSIDIAN_COLORS.borderStrong,
	border3: OBSIDIAN_COLORS.borderStrong,
	border4: OBSIDIAN_COLORS.border,
	border5: OBSIDIAN_COLORS.border,
	text1: OBSIDIAN_COLORS.text,
	text2: OBSIDIAN_COLORS.mutedText,
	text3: OBSIDIAN_COLORS.mutedText,
	text4: OBSIDIAN_COLORS.strongText,
};

// Web-only Obsidian tokens for screens the phone app does not have (chat rail, dialogs, lists, links).
// Layers follow Discord: darkest frame and controls, mid-grey panels, sub-menus and dialogs on the page grey,
// and one blurple accent instead of the Sentry orange and blue.
const OBSIDIAN_WEB_THEME_COLORS = {
	mainBg2: OBSIDIAN_COLORS.input,
	mainBg7: OBSIDIAN_COLORS.active,
	mainBg9: OBSIDIAN_COLORS.bgTertiary,
	mainBg11: OBSIDIAN_COLORS.bgTertiary,
	mainBg13: OBSIDIAN_COLORS.hover,
	mainBg16: OBSIDIAN_COLORS.hover,
	mainBg17: OBSIDIAN_COLORS.bgTertiary,
	mainBg19: OBSIDIAN_COLORS.bgTertiary,
	mainBg20: 'transparent',
	mainBg21: OBSIDIAN_COLORS.hover,
	mainBg22: OBSIDIAN_COLORS.active,
	mainBg23: OBSIDIAN_COLORS.bgSecondary,
	mainBg24: OBSIDIAN_COLORS.bgSecondary,
	mainBg28: OBSIDIAN_COLORS.bgSecondary,
	editorToolbarBg: OBSIDIAN_COLORS.bg,
	editorInputBg: OBSIDIAN_COLORS.input,
	border1Active: OBSIDIAN_COLORS.accent,
	border6: OBSIDIAN_COLORS.border,
	shadow1: `0 0 0 1px ${OBSIDIAN_COLORS.border}`,
	inputShadow: `inset 0 0 0 1px ${OBSIDIAN_COLORS.borderStrong}`,
	inputActiveShadow: `inset 0 0 0 1px ${OBSIDIAN_COLORS.accent}, 0 0 0 2px rgba(88, 101, 242, 0.3)`,
	// Unticked boxes need a stronger edge than fields to stay visible on near-black.
	checkboxBorder: '#80848E',
	checkboxSelectedBg: OBSIDIAN_COLORS.accent,
	dragAndDropBg: 'rgba(88, 101, 242, 0.24)',
	primary1: OBSIDIAN_COLORS.accentOnDark,
	text8: OBSIDIAN_COLORS.mutedText,
	text10: OBSIDIAN_COLORS.accentOnDark,
	text11: OBSIDIAN_COLORS.accentOnDark,
	text12: OBSIDIAN_COLORS.mutedText,
	// Disabled fields still show values (prices, costs), so they stay readable on near-black.
	inputDisabledColor: '#80848E',
	// Lighter than dialogs and panels, so disabled buttons and fields keep a visible box.
	inputDisabledBg: OBSIDIAN_COLORS.hover,
	linkColor1: OBSIDIAN_COLORS.accentOnDark,
	// The dark theme's grey series colour is too close to the Obsidian text greys.
	chartColor5: OBSIDIAN_COLORS.mutedText,
	avatarText: OBSIDIAN_COLORS.accentOnDark,
	// Obsidian-only tokens. The other themes leave them unset, so their screens keep their current look.
	headerBg: OBSIDIAN_COLORS.bgTertiary,
	pageBg: OBSIDIAN_COLORS.bg,
	subMenuBg: OBSIDIAN_COLORS.bgSecondary,
	subMenuShadow: `0 0 0 1px ${OBSIDIAN_COLORS.border}`,
	controlBg: OBSIDIAN_COLORS.bgTertiary,
	controlShadow: `inset 0 0 0 1px ${OBSIDIAN_COLORS.borderStrong}`,
	accentFill: OBSIDIAN_COLORS.accent,
	accentFillHover: OBSIDIAN_COLORS.accentHover,
	accentFillActive: OBSIDIAN_COLORS.accentActive,
	dayHoverBg: OBSIDIAN_COLORS.active,
};

// Light in the Sentry web apps only (Sentry Chat and the phone apps keep the shared Light colours): links, blue
// "done" icons and ticked switches share one calm blue, and buttons and dropdowns a thin grey outline, matching the
// tinted status labels instead of a bright blue, Blueprint's dark button edge and solid grey blocks.
export const WEB_LIGHT_THEME_COLORS = {
	linkColor1: '#1d5f96',
	linkHoverColor1: '#174d7a',
	iconColor6: '#1d5f96',
	controlShadow: 'inset 0 0 0 1px rgba(148, 155, 164, 0.6)',
	// Disabled buttons, dropdowns and text boxes.
	inputDisabledBg: 'rgba(148, 155, 164, 0.18)',
	inputDisabledColor: '#858c94',
};

export const isDarkThemeMode = mode => mode === 'dark' || mode === 'darkBlue' || mode === OBSIDIAN_MODE;

// Theme modes offered in the Sentry web apps, in Shift + M order. Plain Dark is hidden on the web,
// but people who already chose it keep it.
export const WEB_THEME_MODE_OPTIONS = [
	{ label: 'Light', value: 'light' },
	{ label: 'Dark blue', value: 'darkBlue' },
	{ label: 'Onyx', value: OBSIDIAN_MODE },
];

// The chat app keeps its own theme so switching it does not change the other web apps.
export const getThemeSettingKey = isChatApp => (isChatApp ? 'chatTheme' : 'theme');

// Plain Dark (or no saved mode) goes back to Light, as the hotkey always did.
export const getNextWebThemeMode = (mode) => {
	const index = WEB_THEME_MODE_OPTIONS.findIndex(option => option.value === mode);
	return index === -1 ? 'light' : WEB_THEME_MODE_OPTIONS[(index + 1) % WEB_THEME_MODE_OPTIONS.length].value;
};

// Status pills (the shared web Label) in the dark themes: a tint of the status colour with lighter text instead of
// a solid fill, so the many all-fine greens and greys sit back. Red gets a stronger tint so problems still stand out.
const darkLabelTint = (rgb, alpha, text, ringAlpha = 0.35) => ({
	bg: `rgba(${rgb}, ${alpha})`,
	hoverBg: `rgba(${rgb}, ${(alpha + 0.03).toFixed(2)})`,
	ring: `rgba(${rgb}, ${ringAlpha})`,
	text,
});
const DARK_LABEL_GREY = darkLabelTint('148, 155, 164', 0.14, '#bcc2ca', 0.3);
const DARK_LABEL_TINTS = {
	label1: DARK_LABEL_GREY,
	label2: darkLabelTint('47, 143, 219', 0.18, '#8ac4f4'),
	label3: darkLabelTint('214, 165, 24', 0.17, '#f0c246'),
	label4: darkLabelTint('61, 173, 87', 0.16, '#72d98d'),
	label5: DARK_LABEL_GREY,
	label6: darkLabelTint('224, 115, 43', 0.18, '#f8ad7b'),
	label7: darkLabelTint('229, 72, 77', 0.28, '#ffaba8', 0.55),
	label8: darkLabelTint('181, 204, 24', 0.16, '#cde05a'),
	label9: darkLabelTint('0, 181, 173', 0.16, '#4fd8cf'),
	label10Black: { bg: 'rgba(0, 0, 0, 0.4)', hoverBg: 'rgba(0, 0, 0, 0.5)', ring: 'rgba(255, 255, 255, 0.14)', text: '#c4c9d0' },
};
// Light uses the same tinted look: a pale tint of the status colour with darker text of the same colour.
const lightLabelTint = (rgb, alpha, text) => ({
	bg: `rgba(${rgb}, ${alpha})`,
	hoverBg: `rgba(${rgb}, ${(alpha + 0.06).toFixed(2)})`,
	ring: `rgba(${rgb}, 0.55)`,
	text,
});
const LIGHT_LABEL_GREY = lightLabelTint('148, 155, 164', 0.24, '#5a5f66');
const LIGHT_LABEL_TINTS = {
	label1: LIGHT_LABEL_GREY,
	label2: lightLabelTint('19, 124, 189', 0.2, '#0f6399'),
	label3: lightLabelTint('245, 182, 0', 0.3, '#7d5c00'),
	label4: lightLabelTint('33, 186, 69', 0.24, '#136c28'),
	label5: LIGHT_LABEL_GREY,
	label6: lightLabelTint('242, 113, 28', 0.24, '#974611'),
	label7: lightLabelTint('219, 40, 40', 0.22, '#ad2020'),
	label8: lightLabelTint('181, 204, 24', 0.3, '#5d680c'),
	label9: lightLabelTint('0, 181, 173', 0.24, '#006a65'),
	label10Black: lightLabelTint('24, 32, 38', 0.14, '#2b3640'),
};

export const themeColors = {
	primary1: {
		// #2185d0
		light: pallete.blue1,
		dark: pallete.blue1,
		darkBlue: pallete.blue1,
	},
	productCategoryColor1: {
		// #dddddd70
		light: pallete.grey1,
		dark: pallete.grey1,
		darkBlue: pallete.grey1,
	},
	productCategoryColor2: {
		// #ffe96080
		light: pallete.yellow1,
		dark: pallete.yellow1,
		darkBlue: pallete.yellow1,
	},
	productCategoryColor3: {
		// #33e2bc50
		light: pallete.green1,
		dark: pallete.green1,
		darkBlue: pallete.green1,
	},
	productCategoryColor4: {
		// #ff8c9e7a
		light: pallete.red1,
		dark: pallete.red1,
		darkBlue: pallete.red1,
	},
	productCategoryBorder1: {
		// #ddd
		light: pallete.grey4,
		dark: pallete.grey4,
		darkBlue: pallete.grey4,
	},
	productCategoryBorder2: {
		// #ffdb65
		light: pallete.yellow2,
		dark: pallete.yellow2,
		darkBlue: pallete.yellow2,
	},
	productCategoryBorder3: {
		// #51d6b9
		light: pallete.green2,
		dark: pallete.green2,
		darkBlue: pallete.green2,
	},
	productCategoryBorder4: {
		// #d2929d
		light: pallete.red2,
		dark: pallete.red2,
		darkBlue: pallete.red2,
	},
	label1: {
		// #E8E8E8 >> #585F67 brand.semantic default
		light: pallete.grey5,
		dark: pallete.grey21,
		darkBlue: pallete.grey21,
	},
	label1Hover: {
		// #dedede
		light: pallete.grey6,
		dark: pallete.grey6,
		darkBlue: pallete.grey6,
	},
	label2: {
		// #137cbd
		light: pallete.blue10,
		dark: pallete.blue10,
		darkBlue: pallete.blue10,
	},
	label2Hover: {
		// #106ba3
		light: pallete.blue8,
		dark: pallete.blue8,
		darkBlue: pallete.blue8,
	},
	label3: {
		// #f5b600 >> #d6a518
		light: pallete.orange1,
		dark: pallete.orange12,
		darkBlue: pallete.orange12,
	},
	label3Hover: {
		// #eaae00 >> #bd9115
		light: pallete.orange2,
		dark: pallete.orange13,
		darkBlue: pallete.orange13,
	},
	label4: {
		// #21ba45 >> #3dad57
		light: pallete.green3,
		dark: pallete.green12,
		darkBlue: pallete.green12,
	},
	label4Hover: {
		// #16ab39 >> #2e8542
		light: pallete.green4,
		dark: pallete.green13,
		darkBlue: pallete.green13,
	},
	label5: {
		// #bcbcbc >> #585F67
		light: pallete.grey7,
		dark: pallete.grey21,
		darkBlue: pallete.grey21,
	},
	label5Hover: {
		// #838383
		light: pallete.grey8,
		dark: pallete.grey8,
		darkBlue: pallete.grey8,
	},
	label6: {
		// #f2711c >> #e0732b
		light: pallete.orange3,
		dark: pallete.orange10,
		darkBlue: pallete.orange10,
	},
	label6Hover: {
		// #f26202 >> #bf5c1b
		light: pallete.orange4,
		dark: pallete.orange11,
		darkBlue: pallete.orange11,
	},
	label7: {
		// #db2828 >> #cf4040
		light: pallete.red3,
		dark: pallete.red10,
		darkBlue: pallete.red10,
	},
	label7Hover: {
		// #d01919 >> #a83434
		light: pallete.red4,
		dark: pallete.red11,
		darkBlue: pallete.red11,
	},
	label8: {
		// brand.semantic.simple.olive #b5cc18
		light: pallete.green5,
		dark: pallete.green5,
		darkBlue: pallete.green5,
	},
	label8Hover: {
		// #a7bd0d
		light: pallete.green6,
		dark: pallete.green6,
		darkBlue: pallete.green6,
	},
	label9: {
		// brand.semantic.simple.teal #00b5ad
		light: pallete.green7,
		dark: pallete.green7,
		darkBlue: pallete.green7,
	},
	label9Hover: {
		// #009c95
		light: pallete.green8,
		dark: pallete.green8,
		darkBlue: pallete.green8,
	},
	label10Black: {
		// #009c95
		light: pallete.black3,
		dark: pallete.black3,
		darkBlue: pallete.black3,
	},
	labelText1: {
		// #fff
		light: pallete.white1,
		dark: pallete.white1,
		darkBlue: pallete.white1,
	},
	labelText2: {
		// #182026 >> #fff
		light: pallete.black2,
		dark: pallete.white1,
		darkBlue: pallete.white1,
	},
	labelTextShadow: {
		// .05rem .05rem #888
		light: pallete.textShadow1,
		dark: pallete.textShadow1,
		darkBlue: pallete.textShadow1,
	},
	// Per Label colour scheme overrides: { bg, hoverBg, ring, text }. Web only; the phone apps keep the label tokens.
	labelTints: {
		light: LIGHT_LABEL_TINTS,
		dark: DARK_LABEL_TINTS,
		darkBlue: DARK_LABEL_TINTS,
	},
	iconColor1: {
		// #545f7d >> #bcbcbc
		light: pallete.grey39,
		dark: pallete.grey7,
		darkBlue: pallete.grey7,
	},
	iconColor2: {
		// #999999 >> #bcbcbc default icon color'
		light: pallete.grey3,
		dark: pallete.grey7,
		darkBlue: pallete.grey7,
	},
	iconColor3: {
		// #727fa3
		light: pallete.grey9,
		dark: pallete.grey9,
		darkBlue: pallete.grey9,
	},
	iconColor4: {
		// #f5b600 >> #d6a518
		light: pallete.orange1,
		dark: pallete.orange12,
		darkBlue: pallete.orange12,
	},
	iconColor5: {
		// #f2711c >> #e0732b
		light: pallete.orange3,
		dark: pallete.orange10,
		darkBlue: pallete.orange10,
	},
	iconColor6: {
		// #2185d0
		light: pallete.blue11,
		dark: pallete.blue11,
		darkBlue: pallete.blue11,
	},
	iconColor7: {
		// #21ba45 >> #3dad57
		light: pallete.green3,
		dark: pallete.green12,
		darkBlue: pallete.green12,
	},
	iconColor8: {
		// #db2828 >> #cf4040
		light: pallete.red3,
		dark: pallete.red10,
		darkBlue: pallete.red10,
	},
	iconColor9: {
		// #af5b5e
		light: pallete.red9,
		dark: pallete.red9,
		darkBlue: pallete.red9,
	},
	iconColor10: {
		// #be37db
		light: pallete.purple1,
		dark: pallete.purple1,
		darkBlue: pallete.purple1,
	},
	iconColor11: {
		// #66aeff
		light: pallete.blue12,
		dark: pallete.blue12,
		darkBlue: pallete.blue12,
	},
	iconColor12: {
		// #ccc
		light: pallete.grey24,
		dark: pallete.grey24,
		darkBlue: pallete.grey24,
	},
	iconColor13: {
		// #bbb
		light: pallete.grey37,
		dark: pallete.grey37,
		darkBlue: pallete.grey37,
	},
	iconColor14: {
		// Navy for Rocket tier
		light: pallete.navy1,
		dark: pallete.navy1,
		darkBlue: pallete.navy1,
	},
	iconColor15: {
		// Pink for Supernova tier
		light: pallete.pink1,
		dark: pallete.pink1,
		darkBlue: pallete.pink1,
	},
	iconColor16: {
		// Black for Black hole tier
		light: pallete.black2,
		dark: pallete.white1,
		darkBlue: pallete.white1,
	},
	iconColor17: {
		// Rainbow/multi for Transcendence tier (will use gradient)
		light: pallete.purple1,
		dark: pallete.purple1,
		darkBlue: pallete.purple1,
	},
	iconColor18: {
		// Banana yellow
		light: pallete.banana1,
		dark: pallete.banana1,
		darkBlue: pallete.banana1,
	},
	inactiveListRow: {
		light: pallete.grey6,
		dark: pallete.grey31,
		darkBlue: pallete.grey31,
	},
	coinMechTubeLow: {
		// #de3232
		light: pallete.red8,
		dark: pallete.red8,
		darkBlue: pallete.red8,
	},
	coinMechTubeHight: {
		// #00aaff
		light: pallete.blue9,
		dark: pallete.blue9,
		darkBlue: pallete.blue9,
	},
	predictedQuantityColor1: {
		// #21ba45 >> #3dad57
		light: pallete.green3,
		dark: pallete.green12,
		darkBlue: pallete.green12,
	},
	predictedQuantityColor2: {
		// #272f3b
		light: pallete.black1,
		dark: pallete.black1,
		darkBlue: pallete.black1,
	},
	markerColor1: {
		// #db2828 >> #cf4040
		light: pallete.red3,
		dark: pallete.red10,
		darkBlue: pallete.red10,
	},
	markerColor2: {
		// #bcbcbc
		light: pallete.grey7,
		dark: pallete.grey7,
		darkBlue: pallete.grey7,
	},
	markerColor3: {
		// #f5b600 >> #d6a518
		light: pallete.orange1,
		dark: pallete.orange12,
		darkBlue: pallete.orange12,
	},
	markerColor4: {
		// #21ba45 >> #3dad57
		light: pallete.green3,
		dark: pallete.green12,
		darkBlue: pallete.green12,
	},
	dragAndDropBg: {
		// #378abb12
		light: pallete.blue3,
		dark: pallete.blue3,
		darkBlue: pallete.blue3,
	},
	border1: {
		// #E8E8E8 >> rgba(32, 34, 37, 0.5)
		light: pallete.grey5,
		dark: pallete.grey22,
		darkBlue: pallete.grey22,
	},
	border1Active: {
		// #f2711c active tab item
		light: pallete.orange5,
		dark: pallete.orange5,
		darkBlue: pallete.orange5,
	},
	border2: {
		// #bcbcbc >> rgba(32, 34, 37, 0.5)
		light: pallete.grey7,
		dark: pallete.grey22,
		darkBlue: pallete.grey22,
	},
	border3: {
		// #dedede >> #a7b6c2 dividers
		light: pallete.grey6,
		dark: pallete.grey16,
		darkBlue: pallete.grey16,
	},
	border4: {
		// #ddd >> rgba(32, 34, 37, 0.5)
		light: pallete.grey4,
		dark: pallete.grey22,
		darkBlue: pallete.grey22,
	},
	border5: {
		// #e0e0e0d1 >> rgba(32, 34, 37, 0.5)
		light: pallete.grey35,
		dark: pallete.grey22,
		darkBlue: pallete.grey22,
	},
	border6: {
		// #c9cdcf >> rgba(32, 34, 37, 0.5)
		light: pallete.grey41,
		dark: pallete.grey22,
		darkBlue: pallete.grey22,
	},
	mainBg1: {
		// #fff >> #36393F >> #18202f dashboard & panes
		light: pallete.white1,
		dark: pallete.grey18,
		darkBlue: pallete.blue15,
	},
	mainBg2: {
		// #d8e1e8 >> #393C43 >> #283245 selected tab, table header
		light: pallete.grey28,
		dark: pallete.grey19,
		darkBlue: pallete.blue17,
	},
	mainBg3: {
		// #ebf6ff >> #34373C >> hover effect on tabs (in both light and dark mode) and list items (only in dark mode)
		light: pallete.grey29,
		dark: pallete.grey17,
		darkBlue: pallete.blue18,
	},
	mainBg4: {
		// #fbfbfb66 >> #2F3136 main app bg
		light: pallete.grey32,
		dark: pallete.grey20,
		darkBlue: pallete.blue15,
	},
	mainBg5: {
		// #E4E9ED >> #4f545c menu and button hover; disabled input
		light: pallete.grey13,
		dark: pallete.grey25,
		darkBlue: pallete.grey25,
	},
	mainBg6: {
		// #2185d0 some obscure usage in PlanogramItemFooter
		light: pallete.blue1,
		dark: pallete.blue1,
		darkBlue: pallete.blue1,
	},
	mainBg7: {
		// #E4E9ED >> #585F67 Dashboard link hover state in Header, hover and selection range in date range selection popup
		light: pallete.grey13,
		dark: pallete.grey21,
		darkBlue: pallete.grey21,
	},
	mainBg8: {
		// #fff >> #43464a >> #414c63 tooltip
		light: pallete.white1,
		dark: pallete.grey46,
		darkBlue: pallete.blue19,
	},
	mainBg9: {
		// #fff >> #202225 >> #323e54 form datepicker bg, map zoom controls bg
		light: pallete.white1,
		dark: pallete.grey23,
		darkBlue: pallete.blue18,
	},
	mainBg10: {
		// #fff >> #292b2f >> #283245 number, edit-in-place field
		light: pallete.white1,
		dark: pallete.grey27,
		darkBlue: pallete.blue17,
	},
	mainBg11: {
		// #CCC >> #202225 >> #323e54 scrollbar thumb bg
		light: pallete.grey24,
		dark: pallete.grey23,
		darkBlue: pallete.blue18,
	},
	mainBg12: {
		// #E4E9ED >> #34373C scrollbar track bg
		light: pallete.grey13,
		dark: pallete.grey17,
		darkBlue: pallete.blue19,
	},
	mainBg13: {
		// #fff >> #2F3136 planogram item bg
		light: pallete.white1,
		dark: pallete.grey38,
		darkBlue: pallete.grey38,
	},
	mainBg14: {
		// #d8e1e8 >> #d8e1e8 day hover bg
		light: pallete.grey28,
		dark: pallete.grey28,
		darkBlue: pallete.grey28,
	},
	mainBg15: {
		// #f5f8fa >> #292b2f >> #283245 button bg, layout dialog datepicker bg
		light: pallete.grey14,
		dark: pallete.grey27,
		darkBlue: pallete.blue17,
	},
	mainBg16: {
		// #E4E9ED >> #202225 >> #323e54 button bg hover
		light: pallete.grey13,
		dark: pallete.grey23,
		darkBlue: pallete.blue18,
	},
	mainBg17: {
		// #f4f7fb >> #393C43 >> #212939 list header
		light: pallete.grey33,
		dark: pallete.grey25,
		darkBlue: pallete.blue16,
	},
	mainBg18: {
		// #fff >> #292b2f >> #283245 dropdown bg
		light: pallete.white1,
		dark: pallete.grey27,
		darkBlue: pallete.blue17,
	},
	mainBg19: {
		// #d8e1e8 >> #202225 >> #323e54 active dropdown btn
		light: pallete.grey28,
		dark: pallete.grey23,
		darkBlue: pallete.blue18,
	},
	mainBg20: {
		// #fff8f1 >> #393C43 >> #283245 bg of the selected horizontal/vertical tab
		light: pallete.orange6,
		dark: pallete.grey19,
		darkBlue: pallete.blue17,
	},
	mainBg21: {
		// #fef8f1 >> #34373C >> bg of the hovered horizontal/vertical tab
		light: pallete.orange7,
		dark: pallete.grey17,
		darkBlue: pallete.blue18,
	},
	mainBg22: {
		// #ffe9d3 >> #393C43 >> #283245 bg of the selected vertical tab
		light: pallete.orange9,
		dark: pallete.grey17,
		darkBlue: pallete.blue17,
	},
	mainBg23: {
		// #ebf1f5 >> #36393F >> #212939 bp6- dialogues
		light: pallete.grey40,
		dark: pallete.grey18,
		darkBlue: pallete.blue16,
	},
	mainBg24: {
		// #fff >> #2F3136 >> #18202f bp6-dialogue header
		light: pallete.white1,
		dark: pallete.grey20,
		darkBlue: pallete.blue15,
	},
	mainBg25: {
		// #eceffa >> #5d616b selected planogram item
		light: pallete.grey42,
		dark: pallete.grey45,
		darkBlue: pallete.grey45,
	},
	mainBg26: {
		// rgba(206, 217, 224, 0.5) >> rgba(206, 217, 224, 0.5) disabled planogram item
		light: pallete.grey11,
		dark: pallete.grey11,
		darkBlue: pallete.grey11,
	},
	mainBg27: {
		// #fff1d2 >> #4f545c queued planogram item
		light: pallete.grey43,
		dark: pallete.grey25,
		darkBlue: pallete.grey25,
	},
	mainBg28: {
		// #fff >> #36393F >> #212939 raised page BG
		light: pallete.white1,
		dark: pallete.grey18,
		darkBlue: pallete.blue16,
	},
	editorToolbarBg: {
		// #fff >> #36393F >> #212939
		light: pallete.white1,
		dark: pallete.grey18,
		darkBlue: pallete.blue16,
	},
	editorInputBg: {
		// #fff >> #2F3136 >> #18202f
		light: pallete.white1,
		dark: pallete.grey20,
		darkBlue: pallete.blue19,
	},
	editorBtnBg: {
		// #fff >> #4f545c >> #18202f
		light: pallete.white1,
		dark: pallete.grey25,
		darkBlue: pallete.blue18,
	},
	datePickerToday: {
		// #ffe9d3 >> #2F3136 bg for the current day
		light: pallete.orange9,
		dark: pallete.grey20,
		darkBlue: pallete.grey20,
	},
	enableBg1: {
		// #51d6b9 planogram item overlay
		light: pallete.green2,
		dark: pallete.green2,
		darkBlue: pallete.green2,
	},
	disableBg1: {
		// #db2828 >> #cf4040 planogram item overlay
		light: pallete.red3,
		dark: pallete.red10,
		darkBlue: pallete.red10,
	},
	shadow1: {
		// panels
		light: pallete.boxShadow9,
		dark: pallete.boxShadow7,
		darkBlue: pallete.boxShadow7,
	},
	shadow2: {
		// hover on list items
		light: pallete.boxShadow2,
		dark: pallete.boxShadow3,
		darkBlue: pallete.boxShadow3,
	},
	shadow3: {
		// header shadow
		light: pallete.boxShadow8,
		dark: pallete.boxShadow7,
		darkBlue: pallete.boxShadow7,
	},
	shadow4: {
		// planogram items, planogram edit panel
		light: pallete.boxShadow10,
		dark: pallete.boxShadow7,
		darkBlue: pallete.boxShadow7,
	},
	shadow5: {
		// PlanogramDetailAddLayoutItem, PlanogramDialogPlanogramSettings
		light: pallete.boxShadow1,
		dark: pallete.boxShadow7,
		darkBlue: pallete.boxShadow7,
	},
	text1: {
		// #182026 >> #b9bbbe header Dashobard link, some route tabs
		light: pallete.black2,
		dark: pallete.grey36,
		darkBlue: pallete.grey36,
	},
	text2: {
		// #999999 >> #a7b6c2 subtext, placeholders, breadcrumbs here
		light: pallete.grey3,
		dark: pallete.grey16,
		darkBlue: pallete.grey16,
	},
	text3: {
		// #727272 >> #a7b6c2 sub headers, ticks and other text for charts
		light: pallete.grey2,
		dark: pallete.grey16,
		darkBlue: pallete.grey16,
	},
	text4: {
		// #f5f8fa text on colored bg
		light: pallete.grey14,
		dark: pallete.grey14,
		darkBlue: pallete.grey14,
	},
	text5: {
		// #21ba45 >> #3dad57 buying list - required items
		light: pallete.green3,
		dark: pallete.green12,
		darkBlue: pallete.green12,
	},
	text6: {
		// #db2828 >> #cf4040 buying list - not required items, danger intent item
		light: pallete.red3,
		dark: pallete.red10,
		darkBlue: pallete.red10,
	},
	text7: {
		// #182026 always black
		light: pallete.black2,
		dark: pallete.black2,
		darkBlue: pallete.black2,
	},
	text8: {
		// #999999 >> #838383 placeholder text, coin mech 'No fill required'
		light: pallete.grey3,
		dark: pallete.grey8,
		darkBlue: pallete.grey8,
	},
	text9: {
		// #CCC >> #838383 planogram item 'No Product Selected' text
		light: pallete.grey24,
		dark: pallete.grey10,
		darkBlue: pallete.grey10,
	},
	text10: {
		// #ff8100 >> #ff8100 activeLabel text (vertical tabs)
		light: pallete.orange8,
		dark: pallete.orange8,
		darkBlue: pallete.orange8,
	},
	text11: {
		// #106ba3 >> #1b8de3 primary intent dropdown item text color
		light: pallete.blue8,
		dark: pallete.blue14,
		darkBlue: pallete.blue14,
	},
	text12: {
		// #727272 >> #8e9297 >> #a7b6c2 hint text color, lighter in Dark blue for its raised panels
		light: pallete.grey2,
		dark: pallete.grey44,
		darkBlue: pallete.grey16,
	},
	linkColor1: {
		// #106ba3 >> #1b8de3 links and selection color
		light: pallete.blue8,
		dark: pallete.blue14,
		// Lighter than Dark's blue so links stay readable on hovered rows and raised panels.
		darkBlue: pallete.blue12,
	},
	percentColor1: {
		// #f2711c once inside some report
		light: pallete.orange3,
		dark: pallete.orange3,
		darkBlue: pallete.orange3,
	},
	percentColor2: {
		// #2185d0 once inside some report
		light: pallete.blue1,
		dark: pallete.blue1,
		darkBlue: pallete.blue1,
	},
	importantColor1: {
		// #db2828 >> #cf4040
		light: pallete.red3,
		dark: pallete.red10,
		darkBlue: pallete.red10,
	},
	jsPDFColor: {
		// #2185d0
		light: pallete.blue1,
		dark: pallete.blue1,
		darkBlue: pallete.blue1,
	},
	chartColor0: {
		// #173F5F >> #106ba3
		light: pallete.blue4,
		dark: pallete.blue8,
		darkBlue: pallete.blue8,
	},
	chartColor1: {
		// #20639B >> #66aeff
		light: pallete.blue6,
		dark: pallete.blue12,
		darkBlue: pallete.blue12,
	},
	chartColor2: {
		// #3CAEA3 >> #
		light: pallete.green9,
		dark: pallete.green3,
		darkBlue: pallete.green3,
	},
	chartColor3: {
		// #ffdb65
		light: pallete.yellow2,
		dark: pallete.yellow2,
		darkBlue: pallete.yellow2,
	},
	chartColor4: {
		// #ED553B
		light: pallete.red5,
		dark: pallete.red5,
		darkBlue: pallete.red5,
	},
	chartColor5: {
		// #182026 >> #a7b6c2, a near-black series disappears on dark panels
		light: pallete.black2,
		dark: pallete.grey16,
		darkBlue: pallete.grey16,
	},
	chartBg0: {
		// #173F5F20 >> #173F5F80
		light: pallete.blue5,
		dark: pallete.blue13,
		darkBlue: pallete.blue13,
	},
	chartBg1: {
		// #20639B20
		light: pallete.blue7,
		dark: pallete.blue7,
		darkBlue: pallete.blue7,
	},
	chartBg2: {
		// #3CAEA320
		light: pallete.green10,
		dark: pallete.green10,
		darkBlue: pallete.green10,
	},
	chartBg3: {
		// #F6D55C20
		light: pallete.yellow3,
		dark: pallete.yellow3,
		darkBlue: pallete.yellow3,
	},
	chartBg4: {
		// #ED553B20
		light: pallete.red6,
		dark: pallete.red6,
		darkBlue: pallete.red6,
	},
	chartBg5: {
		// #182026
		light: pallete.black2,
		dark: pallete.black2,
		darkBlue: pallete.black2,
	},
	chartBg6: {
		// #4B0082
		light: pallete.purple2,
		dark: pallete.purple2,
		darkBlue: pallete.purple2,
	},
	inputShadow: {
		//
		light: pallete.boxShadow6,
		dark: pallete.boxShadow7,
		darkBlue: pallete.boxShadow7,
	},
	inputActiveShadow: {
		//
		light: pallete.boxShadow4,
		dark: pallete.boxShadow5,
		darkBlue: pallete.boxShadow5,
	},
	inputDisabledColor: {
		// rgba(92, 112, 128, 0.6)
		light: pallete.grey10,
		dark: pallete.grey10,
		darkBlue: pallete.grey10,
	},
	inputDisabledBg: {
		// #E4E9ED >> #4f545c >> #283245 menu and button hover; disabled input
		light: pallete.grey13,
		dark: pallete.grey27,
		darkBlue: pallete.blue17,
	},
	checkboxBorder: {
		// #2185d0
		light: pallete.blue1,
		dark: pallete.blue1,
		darkBlue: pallete.blue1,
	},
	checkboxChekmarkColor: {
		// #fff
		light: pallete.white1,
		dark: pallete.white1,
		darkBlue: pallete.white1,
	},
	checkboxSelectedBg: {
		// #2185d0
		light: pallete.blue1,
		dark: pallete.blue1,
		darkBlue: pallete.blue1,
	},
	checkboxDisabledBg: {
		// rgba(206, 217, 224, 0.5)
		light: pallete.grey11,
		dark: pallete.grey11,
		darkBlue: pallete.grey11,
	},
	checkboxDisabledBorder: {
		// rgba(206, 217, 224, 0.5)
		light: pallete.grey11,
		dark: pallete.grey11,
		darkBlue: pallete.grey11,
	},
	checkboxDisabledChekmarkColor: {
		// rgba(92, 112, 128, 0.6)
		light: pallete.grey10,
		dark: pallete.grey10,
		darkBlue: pallete.grey10,
	},
	chartPointBg: {
		// #fff
		light: pallete.white1,
		dark: pallete.white1,
		darkBlue: pallete.white1,
	},
	chartPointBorder: {
		// #00b5ad
		light: pallete.green7,
		dark: pallete.green7,
		darkBlue: pallete.green7,
	},
	chartPointHoverBorder: {
		// #dedede
		light: pallete.grey6,
		dark: pallete.grey6,
		darkBlue: pallete.grey6,
	},
	spinnerBg: {
		// 'rgba(255, 255, 255, 0.3) >> rgba(47, 49, 54, 0.3) >> rgba(24, 32, 47, 0.3)
		light: pallete.grey30,
		dark: pallete.grey31,
		darkBlue: pallete.blue20,
	},
	planogramGreen: {
		// #21ba45 planogram stats
		light: pallete.green3,
		dark: pallete.green3,
		darkBlue: pallete.green3,
	},
	planogramGreenFooter: {
		// #B7E4A6 >> #9bb88f planogram stats
		light: pallete.green14,
		dark: pallete.green15,
		darkBlue: pallete.green15,
	},
	planogramAmber: {
		// #f5b600 planogram stats
		light: pallete.orange1,
		dark: pallete.orange1,
		darkBlue: pallete.orange1,
	},
	planogramAmberFooter: {
		// #FED89E >> #d9bd93 planogram stats
		light: pallete.yellow4,
		dark: pallete.yellow5,
		darkBlue: pallete.yellow5,
	},
	planogramRed: {
		// #db2828 planogram stats
		light: pallete.red3,
		dark: pallete.red3,
		darkBlue: pallete.red3,
	},
	planogramRedFooter: {
		// #F5BEBE >> #c9a1a1 planogram stats
		light: pallete.red12,
		dark: pallete.red13,
		darkBlue: pallete.red13,
	},
	planogramGrey: {
		// #838383 planogram stats
		light: pallete.grey8,
		dark: pallete.grey8,
		darkBlue: pallete.grey8,
	},
	planogramGreyFooter: {
		// #EEE >> #2F3136 planogram stats
		light: pallete.grey34,
		dark: pallete.grey3,
		darkBlue: pallete.grey3,
	},
	planogramItemLowQuantity: {
		// #cf4040
		light: pallete.red10,
		dark: pallete.red10,
		darkBlue: pallete.red10,
	},
	planogramItemMidQuantity: {
		// #ffdb65
		light: pallete.yellow2,
		dark: pallete.yellow2,
		darkBlue: pallete.yellow2,
	},
	planogramItemHighQuantity: {
		// #21ba45
		light: pallete.green3,
		dark: pallete.green3,
		darkBlue: pallete.green3,
	},
	notEditablePlanogramItemInput: {
		// #5c7080
		light: pallete.grey47,
		dark: pallete.grey47,
		darkBlue: pallete.grey47,
	},
	editablePlanogramItemCurrencyInput: {
		// #182026 >> #b9bbbe
		light: pallete.black2,
		dark: pallete.grey36,
		darkBlue: pallete.grey36,
	},
	calendarWeekendDayBg: {
		// #fbfbfb66 >> #2F3136 >> #18202f main app bg
		light: pallete.grey32,
		dark: pallete.grey20,
		darkBlue: pallete.blue19,
	},
	fakeListHeaderColor: {
		light: pallete.grey33,
		dark: pallete.grey25,
		darkBlue: pallete.blue16,
	},
	success1: {
		light: pallete.statusGreen1,
		dark: pallete.statusGreen1,
		darkBlue: pallete.statusGreen1,
	},
	warning1: {
		light: pallete.statusAmber1,
		dark: pallete.statusAmber1,
		darkBlue: pallete.statusAmber1,
	},
	danger1: {
		light: pallete.statusRed1,
		dark: pallete.statusRed1,
		darkBlue: pallete.statusRed1,
	},
	info1: {
		light: pallete.statusBlue1,
		dark: pallete.statusBlue1,
		darkBlue: pallete.statusBlue1,
	},
	avatarText: {
		// #2185d0 >> #66aeff, initials on the avatar circle (mainBg3)
		light: pallete.blue1,
		dark: pallete.blue12,
		darkBlue: pallete.blue12,
	},
	// Dark themes get the shared dark overrides for Blueprint's light-theme defaults (createCustomStyles).
	colorScheme: {
		light: 'light',
		dark: 'dark',
		darkBlue: 'dark',
	},
	dayHoverBg: {
		// #d8e1e8 >> #414c63 date picker day hover, one step lighter than the picker
		light: pallete.grey28,
		dark: pallete.grey25,
		darkBlue: pallete.blue19,
	},
};

export const getTheme = (mode = 'light') => {
	if (mode === OBSIDIAN_MODE) {
		return { ...getTheme('dark'), ...OBSIDIAN_THEME_COLORS, ...OBSIDIAN_WEB_THEME_COLORS };
	}
	return Object.keys(themeColors).reduce((acc, key) => {
		acc[key] = themeColors[key][mode]
			? themeColors[key][mode]
			: themeColors[key].light;
		return acc;
	}, {});
};
